import { css, Stack, Typography } from '@mui/material'
import { FC, ReactNode, SVGProps } from 'react'
import { unifiedColors } from 'styles/colors'

interface AutocompleteResultRowProps<T> {
  item?: T
  setItem?: (item?: T) => void
  value: string | ReactNode
  Icon: FC<SVGProps<SVGSVGElement>>
  iconBackground: keyof typeof unifiedColors.surface
  background: keyof typeof unifiedColors.surface
}

export const AutocompleteResultRow = <T,>({
  item,
  setItem,
  value,
  Icon,
  iconBackground,
  background
}: AutocompleteResultRowProps<T>) => {
  return (
    <Stack
      flexDirection="row"
      padding="12px"
      gap="13px"
      alignItems="center"
      borderRadius="16px"
      onClick={() => {
        if (setItem) {
          setItem(item)
        }
      }}
      css={css`
        &:hover {
          background: ${unifiedColors.surface[background]};
          cursor: pointer;
        }
      `}
    >
      <Stack
        padding={1}
        borderRadius={2}
        css={css`
          background: ${unifiedColors.surface[iconBackground]};
        `}
      >
        <Icon />
      </Stack>
      {typeof value === 'string' ? (
        <Typography
          variant="body2"
          fontSize={16}
          color={unifiedColors.label.subdued}
          css={css`
            strong {
              color: ${unifiedColors.label.default};
            }
          `}
        >
          {value}
        </Typography>
      ) : (
        value
      )}
    </Stack>
  )
}
